import React from "react";
import "./OurWorkAdd.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";

import img1 from "../../../../assets/images/insights/blog/b1.png";
import img2 from "../../../../assets/images/insights/blog/b2.png";
import img3 from "../../../../assets/images/insights/blog/b3.png";

// ARROW ICON
import arrow from "../../../../assets/icons/arrow.png";
import { Link } from "react-router-dom";

const posts = [
  {
    category: "Service",
    title: "Article name",
    desc: "How do you create compelling presentations that wow your colleagues and impress your managers?",
    image: img1,
  },
  {
    category: "Service",
    title: "Article name",
    desc: "Linear helps streamline software projects, sprints, tasks, and bug Letter spacing. Here’s how to get started.",
    image: img2,
  },
  {
    category: "Service",
    title: "Article name",
    desc: "The rise of RESTful APIs has been met by a rise in tools for creating, testing, and managing them.",
    image: img3,
  },
];

const OurWorkAdd = () => {
  return (
    <section className="latestblog">

      <div className="latestblog__container">

        {/* HEADER */}
        <div className="latestblog__top">
          <div>
            <span className="latestblog__label">Our Work</span>
            <h2>Related case studies</h2>
            <p>
              Tool and strategies modern teams need to help their companies grow.
            </p>
          </div>

          <button className="buttonclip latestblog__btn">
            View all cases
          </button>
        </div>

        {/* GRID */}
        <Link className="latestblog__grid">
          {posts.map((item, index) => (
            <div key={index} className="latestblog-card">

              {/* IMAGE */}
              <div className="latestblog-card__image">
                <img src={item.image} alt="" />
              </div>

              {/* CONTENT */}
              <div className="latestblog-card__content">

                <CmsText
                  content={item.category}
                  as="span"
                  className="latestblog-card__category"
                />

                <div className="latestblog-card__title-row">
                  <CmsText content={item.title} as="h3" />
                  <img src={arrow} alt="" />
                </div>

                <RichTextContent content={item.desc} />

              </div>

            </div>
          ))}
        </Link>

      </div>

    </section>
  );
};

export default OurWorkAdd;